import {injectable} from "inversify";
import {CNPJResponseEntity} from "@dropDesk/domain/entities/common/cnpj_response.entity";

@injectable()
export abstract class CNPJRepository {
  public abstract searchCNPJ(cnpj: string): Promise<CNPJResponseEntity>;
}
